// GENERATED by scripts/audio-manifest.js — do not edit.
// Re-run with `npm run audio-manifest` (also runs on npm start / build).
export const AUDIO_AVAILABLE: Record<string, string[]> = {
  "de": [
    "intro-session.mp3"
  ]
};
